import { FileText, File, FileCode, FileImage, FileVideo, FileArchive } from 'lucide-react'

export const getFileIcon = (filename: string, mime: string | null = null) => {
    const lowerName = filename.toLowerCase()

    if (lowerName.endsWith('.pdf') || mime?.includes('pdf')) {
        return <FileText className="w-4 h-4 text-red-500" />
    }
    if (lowerName.endsWith('.md') || mime?.includes('markdown')) {
        return <FileText className="w-4 h-4 text-blue-400" />
    }
    if (lowerName.endsWith('.txt') || mime?.includes('text')) {
        return <FileText className="w-4 h-4 text-gray-400" />
    }
    return <File className="w-4 h-4 text-gray-500" />
}

// Returns the icon component class (not JSX) for use with dynamic rendering
export const getFileIconComponent = (mimeType: string | null) => {
    if (!mimeType) return FileText

    if (mimeType.includes('pdf')) return FileText
    if (mimeType.includes('markdown')) return FileText
    if (mimeType.includes('text')) return FileText
    if (mimeType.includes('code') || mimeType.includes('javascript') || mimeType.includes('typescript')) return FileCode
    if (mimeType.includes('image')) return FileImage
    if (mimeType.includes('video')) return FileVideo
    if (mimeType.includes('zip') || mimeType.includes('archive')) return FileArchive

    return FileText
}
